var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"insights-filters"}},[_c('StructureSelect',{attrs:{"images":_vm.reformattedImages,"index":_vm.index,"pImages":_vm.pImages}}),_c('FaultSummaryFilters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }